import useGetConfigResponder from 'hooks/responder/useGetConfigResponder';

export default useGetConfigResponder;

//! DEPRECATED!!
// /* */
// import Timer from 'helpers/setTimer';
// import { isEmpty, isObject } from 'lodash';
// import { useEffect, useMemo } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import actions from 'redux/actions';

// const { getLoadConfig } = actions;

// const timer = new Timer();

// export default () => {
//   const dispatch = useDispatch();
//   const authReducer = useSelector((state) => state.authReducer);
//   const configs = useSelector((state) => state.othersReducer.listConfig);
//   const isConfigLoaded = !isEmpty(configs);

//   useEffect(() => {
//     if (!authReducer.isLogin || !authReducer.sessionId || isConfigLoaded) {
//       return;
//     }

//     timer.debounce(() => {
//       dispatch(getLoadConfig());
//     }, 200);
//   }, [dispatch, authReducer.isLogin, isConfigLoaded]);

//   return useMemo(() => {
//     return isObject(configs) ? configs : {};
//   }, [configs]);
// };
